import { get_axios_file_download_instance, get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';
import { param } from 'jquery';
var axios_instance_FBP_Claimed_report = get_axios_instance(api_variables.SERVICE_FBP_CLAIMED_REPORT);
var axios_instance_FBP_Un_Calimed_report = get_axios_instance(api_variables.SERVICE_FBP_UN_CLAIMED_REPORT);

const state = {
    data: [],
    isFetching: false,
};

const mutations = {
    set: (state, payload) => {
        state.data = payload;
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

}
const actions = {
    async downloadClaimedReport({ commit }, payload) {
        try {
            let res = await axios_instance_FBP_Claimed_report.get('/', {params:{
            financial_year:payload.financial_year,
            le_id: payload.le_id,
            month:payload.month,
            }});;
            // PL_3064
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload;
                link.setAttribute("download", "Salary_Register_Report.xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async downloadUnClaimedReport({ commit }, payload) {
        try {
            let res = await axios_instance_FBP_Un_Calimed_report.get('/', {params:{
                le_id: payload.le_id,
                financial_year:payload.financial_year
            }});;
            // PL_3064
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload;
                link.setAttribute("download", "Salary_Register_Report.xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
}

export default {
    namespaced: true,
    actions,
    mutations,
    state
};